import React, { useEffect, useState } from "react";

import { Grid } from "@material-ui/core";

import {
  FormDataConsumer,
  minValue,
  number,
  NumberInput,
  required,
  SelectInput,
  TextInput,
  useNotify,
} from "react-admin";
import { fetchAreas } from "../reloadYard/ReloadYardUtils";

export const AssetTypeForm = (props) => {
  const notify = useNotify();
  const [areas, setAreas] = useState(
    () =>
      window.appUser.reloadYard?.areas?.items.filter(
        (itm) => itm.active === "true"
      ),
    []
  );
  const { eventTypes } = props;
  const [minConcurrentBookings, setMinConcurrentBookings] = useState(1);

  useEffect(() => {
    fetchAreas(setAreas, notify);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (eventTypes?.length > 0) {
      const minResources = Math.min(
        ...eventTypes.map((et) => et.numberOfResources || 1)
      );
      setMinConcurrentBookings(minResources);
    }
  }, [eventTypes]);

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <Grid container item spacing={2}>
          <Grid item xs={3}>
            <TextInput
              label="Resource Name"
              source="name"
              variant="outlined"
              fullWidth
              validate={required()}
              helperText={false}
            />
          </Grid>
          <Grid item xs={3}>
            <NumberInput
              label="Max. Concurrent Bookings"
              source="maxConcurrentBookings"
              variant="outlined"
              fullWidth
              min={minConcurrentBookings}
              validate={[
                required(),
                number(),
                minValue(
                  minConcurrentBookings,
                  `Must be ${minConcurrentBookings} or greater.`
                ),
              ]}
              helperText="Number of available assets."
            />
          </Grid>
          <Grid item xs={3}>
            <SelectInput
              label="Area"
              source="areaId"
              variant="outlined"
              fullWidth
              choices={areas}
              allowEmpty
              resettable
              helperText={false}
            />
          </Grid>
        </Grid>
      )}
    </FormDataConsumer>
  );
};
